import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackMeta } from "@/analytics/pixels";

export const RouteTracker = () => {
  const location = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    const pagePath = `${location.pathname}${location.search}`;
    trackMeta("PageView", { page_path: pagePath, page_title: document.title });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "virtual_page_view",
      page_path: pagePath,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [location]);

  return null;
};
